import { Platform } from 'react-native';

/**
 * Platform utility for calendar integration
 * Determines device calendar access capabilities
 */

export const canAccessDeviceCalendar = (): boolean => {
  return Platform.OS === 'android' || Platform.OS === 'ios';
};
